<template>
	<div class="Notice">
		<div class="header">
			<rs-row>
				<rs-col :span="24">
					<div class="grid-content bg-purple-dark">
						<img @click="back" style="cursor: pointer; width: 20px; height: 20px" src="../assets/返回.png"
							alt="" />
						<span style="margin-left: 10px">公告详情</span>
					</div>
				</rs-col>
			</rs-row>
		</div>
		<div class="main" >
			<div class="main_header">
				{{list.noticeTitle}}
			</div>
			<div class="main_Main" >
				<span style="padding:10px">
					{{list.releaseTime}}
				</span>
				<p style="width:90%;line-height:2em;padding:10px" v-html="list.noticeText">
				</p>
			</div>
			<!-- <div  class="main_Fotter">
				<p   @click="mstop">上一条：系统公告</p>
				<p  @click="msbottom">下一条：系统公告</p>
			</div> -->
		</div>
	</div>
</template>
<script>
	import API from "@/api/pay";
	import Until from "../../../utils/utils";
	export default {
		data() {
			return {
				//获取来的数据储存
				pageData: '',
				// 总页数
				pageCount: '',
				// 当前页码
				pageNum: '',
				//当前是第一页
				selectPage: 1,
				list:[],
               noticeId:'',
			   Onlinepayment:''
			}
		},
		created() {
			this.noticeId=this.$route.query.id
		  this.getlist()
		},
		methods: {
			//获取公告详情
			getlist(){
				let phone = Until.getSession("shopVo");
				console.log(phone)
				let params={
					noticeId:this.noticeId,
					businessId:phone
				}
				API.announCemementDeatil(params).then((res)=>{
					this.list=res.data.data
				})
			},
			back() {
				this.$router.go(-1);
			},

		},
	};
</script>
<style lang='scss' scoped>
	.Notice {
		height: 100%;
		background-color: #ebebeb;
	}

	.rs-row {
		margin-bottom: 20px;

		&:last-child {
			margin-bottom: 0;
		}
	}

	.bg-purple-dark {
		background-color: #ffffff;
		color: black;
		font-weight: bold;
		font-size: 15px;
		padding-left: 20px;
		display: flex;
		align-items: center;
	}

	.grid-content {
		/* border-radius: 4px; */
		height: 40px;
		line-height: 40px;
	}

	.main {
		padding: 10px;
		margin-top: 10px;

	}

	.main_header {
		background: white;
		padding: 10px;
		border-bottom: 1px solid #ccc;
		height: 50px;
		line-height: 40px;
		text-align: center;
		font-weight: bold;
		font-size: 15px;
		box-shadow: 2px 2px 10px #909090;
	}

	.main_Main {
		background-color: white;
		padding: 10px;
		height: 100%;
		//   box-shadow: 2px 2px 10px #909090;
		//   display: flex;
	}

	.main_Fotter {
		background: white;
		height: 80px;
		box-shadow: 2px 8px 10px #909090;
		padding: 20px;
		line-height: 2em;

	}

	.main_Fotter p {
		cursor: pointer;
	}
</style>
